import React from "react";
const Navigation=({changeRoute,isSigned})=>{
    
    if(isSigned){
            return(
            <nav style={{display:'flex' , justifyContent:'end'}}>
                {/* <p onClick={()=>{changeRoute("profile")}} className="f3 link underline pa3 dim black pointer">Profile</p> */}
                <p onClick={()=>{changeRoute("signin")}} className="f3 link underline pa3 dim black pointer">Sign Out</p>
            </nav>
            )
    }
    else{
        return(
            <nav style={{display:'flex' , justifyContent:'end'}}>
                
                <p onClick={()=>{changeRoute("signin")}} className="f3 link underline pa3 dim black pointer">Sign In</p>
                <p onClick={()=>{changeRoute("reg")}} className="f3 link underline pa3 dim black pointer">Register</p>
            </nav>
            )
    }
}
export default Navigation;